export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4 flex-wrap justify-center lg:justify-start">
              <span className="px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                每日更新
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                高清画质
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                免费阅读
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              触手漫画 - 触手题材漫画免费在线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              下拉式畅快阅读，海量触手漫画一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              触手漫画网专注触手题材漫画免费在线看服务，汇集异世界、奇幻、科幻、都市等多元触手漫画类型。
              采用下拉式阅读设计，无需翻页即可畅快浏览。每日实时更新最新话，海量触手漫画全集尽在掌握，
              无需下载、无需注册，打开即看，为触手漫画爱好者打造极致的在线阅读体验。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">部触手漫画</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日50+</div>
                <div className="text-xs text-foreground-500 mt-1">话实时更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无需注册</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300 text-foreground-700 rounded-lg font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dynamic%20and%20artistic%20manga-style%20illustration%20featuring%20a%20powerful%20character%20with%20tentacle-like%20energy%20surrounding%20them%2C%20vibrant%20warm%20coral%20and%20amber%20color%20palette%2C%20dramatic%20lighting%20with%20glowing%20highlights%2C%20comic%20book%20aesthetic%20with%20bold%20linework%2C%20stylized%20action%20pose%2C%20dark%20mysterious%20background%20with%20atmospheric%20particles%2C%20Japanese%20manga%20inspired%20art%20style%2C%20epic%20composition%2C%20high%20contrast%2C%20professional%20illustration%20quality&width=800&height=600&seq=hero-main-2026&orientation=landscape"
                alt="触手漫画 - 触手题材漫画免费在线阅读平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}